<template>
  <header :el="mods">
    <slot></slot>
  </header>
</template>

<script>
import { check } from "./verify";
const name = "header";
export default {
  props: ["el"],
  computed: {
    mods() {
      return this.el ? `${name}-${this.el}` : name;
    },
  },
  watch: {
    el(val) {
      check(name, val);
    },
  },
  mounted() {
    check(name, this.el);
  },
};
</script>
<style scoped lang="scss">
[el^="header"] {
  display: grid;
  padding: 0 20px;
  align-items: center;
}
[el^="header"][el*="v-center"],
[el^="header"][el*="vc"] {
  align-items: center;
}
</style>
